import React from "react";
import { MdClose } from "react-icons/md";
import { createPortal } from "react-dom";

import {
  Backdrop,
  ModalContainer,
  Head,
  Content,
} from "components/shared/Modal/Modal.style";
import { Typography } from "@mui/material";

function Modal(props) {
  return createPortal(
    <>
      <Backdrop isShown={props.show} onClick={props.onClose}>
        <ModalContainer
          onClick={(e) => e.stopPropagation()}
          isShown={props.show}
        >
          <Head>
            <MdClose fill="#080a37" size={28} onClick={props.onClose} />
            {props.title}
          </Head>

          <Content>
            <div>{props.children}</div>
          </Content>
        </ModalContainer>
      </Backdrop>
    </>,
    document.getElementById("modal")
  );
}

export default Modal;
